<template>
  <section class="h-full w-full flex flex-col bg-gradient-to-br from-slate-50 to-blue-50 min-h-screen">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
      <nav class="text-sm text-gray-600 mb-8 flex flex-wrap items-center gap-x-2 gap-y-1">
        <router-link to="/dashboard"
          class="hover:text-blue-600 transition-colors duration-200 font-medium flex items-center">
          <font-awesome-icon icon="home" class="mr-1 text-xs" />
          Dashboard
        </router-link>
        <span class="text-gray-400">/</span>
        <span class="text-blue-700 font-semibold">Timetable</span>
      </nav>

      <faculty-timetable-view v-if="role === 'faculty'" />
      <student-timetable-view v-else-if="role === 'user'" />
      <template v-else>
        <div class="rounded-2xl bg-gradient-to-r from-blue-600 to-indigo-700 shadow-xl p-8 text-white relative overflow-hidden mb-8">
          <div class="absolute inset-0 bg-black opacity-5" aria-hidden="true" />
          <div class="relative z-10">
            <h1 class="text-2xl md:text-3xl font-bold flex items-center gap-3">
              <font-awesome-icon icon="calendar-week" class="opacity-90" />
              Timetable
            </h1>
            <p class="text-blue-100 mt-3 max-w-3xl leading-relaxed">
              View your weekly sessions, times, and locations in one place.
            </p>
          </div>
        </div>
        <div class="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 sm:p-8">
          <p class="text-sm text-gray-600">
            A role-specific timetable view is not available yet. Use Time Table Management or contact your administrator if you need access.
          </p>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
import FacultyTimetableView from './components/FacultyTimetableView.vue';
import StudentTimetableView from './components/StudentTimetableView.vue';

export default {
  name: 'TimetablePage',
  components: {
    FacultyTimetableView,
    StudentTimetableView
  },
  computed: {
    role() {
      return this.$store.getters.role;
    }
  }
};
</script>
